import { useQuery as y } from "@tanstack/vue-query";
import { computed as p, toValue as r } from "vue";
const n = ["campaign"], m = {
  page: 1,
  pageSize: 50,
  sortBy: "createdAt",
  sortDirection: "desc"
}, c = {
  // Prefix for invalidating the entire campaign subtree (lists + every byCampaign).
  // Use `all` in invalidateQueries; use `list(query)` only as a concrete queryKey.
  all: n,
  list: (a) => [...n, "list", a ?? m],
  byCampaign: (a) => [...n, a],
  detail: (a) => [...n, a, "detail"],
  statistics: (a) => [...n, a, "statistics"],
  // POC per-node roll-up. Nested under `statistics` so existing invalidations on statistics(id) also sweep this.
  pocStats: (a) => [...n, a, "statistics", "poc-stats"]
}, u = (a, e, t) => {
  const s = p(() => r(e) ?? m), i = p(() => c.list(s.value));
  return y({
    ...t,
    queryKey: i,
    queryFn: async () => a.campaign.findAll(s.value)
  });
}, d = (a, e, t) => {
  const s = p(() => c.detail(r(e).campaignId));
  return y({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const i = r(e);
      return a.campaign.findOne({ campaignId: i.campaignId });
    }
  });
}, l = (a, e, t) => {
  const s = p(() => c.statistics(r(e).campaignId));
  return y({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const i = r(e);
      return a.campaign.getStatistics({ campaignId: i.campaignId });
    }
  });
}, f = async (a, e, t = m) => {
  await a.prefetchQuery({
    queryKey: c.list(t),
    queryFn: async () => e.campaign.findAll(t)
  });
}, q = async (a, e, t) => {
  await a.prefetchQuery({
    queryKey: c.detail(t.campaignId),
    queryFn: async () => e.campaign.findOne(t)
  });
}, I = async (a, e, t) => {
  await a.prefetchQuery({
    queryKey: c.statistics(t.campaignId),
    queryFn: async () => e.campaign.getStatistics(t)
  });
};
export {
  c as campaignKeys,
  q as prefetchCampaign,
  I as prefetchCampaignStatistics,
  f as prefetchCampaigns,
  d as useCampaign,
  l as useCampaignStatistics,
  u as useCampaigns
};
//# sourceMappingURL=queries.js.map
